import { BaseModel } from '@app/shared/models/base';
import { TranslationEntry } from '@app/shared/models/translatable';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as _ from 'lodash-es';

export class ContactTypes {

    private static readonly all: TranslationEntry[] = [
        { key: 'PHONE', trans: marker('contact.type.phone')},
        { key: 'EMAIL', trans: marker('contact.type.email')},
        { key: 'FAX', trans: marker('contact.type.fax')},
        { key: 'MOBILE', trans: marker('contact.type.mobile')},
        { key: 'URL', trans: marker('contact.type.url')}
    ];

    public static getByKey(key: string): TranslationEntry {
        return _.find(ContactTypes.all, (type: TranslationEntry) => type.key === key);
    }

    public static get PHONE() {
        return ContactTypes.getByKey('PHONE');
    }

    public static get EMAIL() {
        return ContactTypes.getByKey('EMAIL');
    }

    public static get FAX() {
        return ContactTypes.getByKey('FAX');
    }

    public static get MOBILE() {
        return ContactTypes.getByKey('MOBILE');
    }

    public static get URL() {
        return ContactTypes.getByKey('URL');
    }
}

export class Contact extends BaseModel {
    public name: string;
    public value: string;

    public readonly trans = {
        name: marker('contact.name'),
        value: marker('contact.value'),
    };

    constructor(json?: any) {
        super(json);
    }
}
